import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const LogoWrapper = styled.div``;

const LogoImage = styled.div`
  height: auto;
  width: 140px;
  line-height: 1;
  float: left;
  position: relative;
  z-index: 111;
`;

const StyledImg = styled.img`
  width: 140px;
  max-width: 140px;
  height: auto;
`;

const NavBar = () => {
  return (
    <LogoWrapper>
      <LogoImage>
        <Link to="/">
          <StyledImg
            src="//static1.squarespace.com/static/5e82bf31bb25c5136889d5b6/t/5e82c6a442c101597f481c3c/1586270151222/?format=1500w"
            alt="Back Your Local"
          />
        </Link>
      </LogoImage>
    </LogoWrapper>
  );
};

export default NavBar;
